'use client'
import React from "react";
import Button from "@repo/ui/Button";

const GoogleForm = () => {

    const handleGoogleLogin = () => {
        window.location.href = "/api/auth/google"; // Redirect to Next.js API route
    };

    return <Button
        className="inline-flex rounded-md bg-primary font-medium text-white"
        onClick={handleGoogleLogin}>
        Connect
    </Button>

}
export default GoogleForm